import React from 'react';
import Stack, { contentStackSpacing } from '../Stack';
import PressableDynamicOpacity from '../PressableDynamicOpacity';
import { View } from 'react-native';
import Text from '../Text';
import { colors } from '../../../utils/theme';
import { useIsDisabledByParent } from '../IsDisabledProvider';
import { hexToRgbA } from '../../../utils/hexToRGBA';

export type ToggleOption = {
    testId: string;
    title: string;
    value: string;
    color: string;
};

export type ToggleSetOwnProps = {
    value: string;
    onChange: (value: string) => void;
    options: ToggleOption[];
    isDisabled?: boolean;
};

export type ToggleSetProps = ToggleSetOwnProps;

const TOGGLE_HEIGHT = 24;

const ToggleSet: React.FC<ToggleSetProps> = (props) => {
    const isDisabledByParent = useIsDisabledByParent(props.isDisabled);

    return (
        <Stack horizontal space={contentStackSpacing} align="center">
            {props.options.map((option) => {
                const isSelected = option.value === props.value;
                return (
                    <PressableDynamicOpacity
                        key={option.value}
                        onPress={() => props.onChange(option.value)}
                        isDisabled={isDisabledByParent}
                        testID={option.testId}
                    >
                        <View
                            style={{
                                backgroundColor: hexToRgbA(option.color, isSelected ? 1 : 0.4),
                                height: TOGGLE_HEIGHT,
                                borderRadius: TOGGLE_HEIGHT / 2,
                                paddingLeft: TOGGLE_HEIGHT / 2,
                                paddingRight: TOGGLE_HEIGHT / 2,
                                borderWidth: 1,
                                borderColor: isSelected ? colors['Dark-Text'] : hexToRgbA(colors['Gray-Text'], 0.4),
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Text
                                variant={isSelected ? 'bold-caption-1' : 'caption-2'}
                                color={isSelected ? 'Dark-Text' : 'Dark-Text'}
                            >
                                {option.title}
                            </Text>
                        </View>
                    </PressableDynamicOpacity>
                );
            })}
        </Stack>
    );
};

export default React.memo(ToggleSet);
